





















import {Component, Vue} from "vue-property-decorator"
import Header from "@/components/Header.vue";

@Component({
  components: {
    "sa-header": Header
  }
})
export default class App extends Vue {}
